import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3bc2f5c2&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&name=Account&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Account&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3bc2f5c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc2f5c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc2f5c2')) {
      api.createRecord('3bc2f5c2', component.options)
    } else {
      api.reload('3bc2f5c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3bc2f5c2&scoped=true", function () {
      api.rerender('3bc2f5c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account/index.vue"
export default component.exports